module.exports = __webpack_public_path__ + "img/img_sec2_02.ffb00145.png";